import styled from 'styled-components'
import { colors } from '../../theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 30px;
  min-width: 0;
  flex: 1;
`

export const Campo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const CampoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  label {
    font-size: 14px;
    font-weight: 700;
    color: ${colors.grey900};
  }
`

export const CopiarPadraoButton = styled.button`
  border: 1px solid ${colors.secondary};
  background: none;
  color: ${colors.primaryText};
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background: ${colors.accentBg};
    color: ${colors.white};
  }
`

export const Input = styled.input`
  border: 1.5px solid ${colors.grey300};
  border-radius: 8px;
  font-size: 13px;
  padding: 12px;
  width: 100%;
`

export const Textarea = styled.textarea`
  border: 1.5px solid ${colors.grey300};
  border-radius: 8px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
  line-height: 1.5;
  padding: 12px;
  width: 100%;
  resize: vertical;
`

export const EditorPreviewRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: stretch;

  @media screen and (max-width: 1200px) {
    flex-direction: column;
  }
`

export const Coluna = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;

  .coluna-titulo {
    font-size: 12px;
    font-weight: 700;
    color: ${colors.grey700};
  }
`

export const PreviewFrame = styled.iframe`
  border: 1.5px solid ${colors.grey300};
  border-radius: 8px;
  width: 100%;
  min-height: 360px;
  /* EXCECAO ao tema escuro, de proposito: o srcDoc e o HTML real do e-mail,
     um artefato de fundo claro com texto escuro proprio. color-scheme: dark
     nao atravessa a fronteira do documento do iframe, entao escurecer o canvas
     aqui deixaria o e-mail preto sobre escuro. O preview tem de mostrar o
     e-mail como o cliente final vai receber. */
  background: ${colors.white};
`

export const Placeholders = styled.div`
  font-size: 12px;
  color: ${colors.grey700};
  background: ${colors.grey200};
  border-radius: 6px;
  padding: 10px 12px;

  b {
    color: ${colors.grey900};
  }

  code {
    font-family: 'Courier New', Courier, monospace;
    background: ${colors.surface};
    border-radius: 4px;
    padding: 1px 5px;
    margin-right: 6px;
    display: inline-block;
  }
`

export const Acoes = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const SalvarButton = styled.button`
  border: none;
  background-color: ${colors.accentBg};
  color: ${colors.white};
  width: 160px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`
